"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserTypes;
(function (UserTypes) {
    UserTypes[UserTypes["User"] = 0] = "User";
    UserTypes[UserTypes["VendorUser"] = 1] = "VendorUser";
    UserTypes[UserTypes["Anonymous"] = 2] = "Anonymous";
})(UserTypes || (UserTypes = {}));
exports.default = UserTypes;
